<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .cons{
    display: none;
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    width: -moz-fit-content;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    li{
      width: 190px;
      height: 188px;
      margin-right: 170px;
      background: url("../../assets/img/Virus/Virus/fuwu.jpg") no-repeat;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/Virus/Virus/fuwu1.jpg") no-repeat;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .compose-type1{
    padding-bottom: 50px;
    background: url("../../assets/img/Virus/Virus/fuys_bj.png") no-repeat;
    background-size: 100% 100%;
  }
  .required{
    background: none!important;
    margin-left: 0!important;
    margin-top: 80px;
  }
  .desc{
    font-size: 16px;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .effect-lists{
      justify-content: flex-start!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/Virus/Virus/bannerNew.png" class="img-fluid" alt="病毒包装">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/一级标题Banner/病毒包装.jpg" class="img-fluid" alt="病毒包装">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container">
      <p class="desc" style="margin-bottom: 10px;">病毒包装是指利用病毒的天然结构和功能，将外源基因插入病毒基因组中，然后通过病毒感染细胞的方法将该外源基因传递到靶细胞中的过程。这一技术广泛应用于基因治疗、基因功能研究和疫苗开发。擎科生物可提供从序列设计到病毒包装全流程服务。多种规格、多种病毒载体类型可供选择，免疫原性低，滴度高，表达时间长，可满足各种实验需求。</p>
      <p class="desc" style="margin-bottom: 10px;"> <span style="color:#014492;font-weight:bold;cursor: pointer" @click="$router.push('/Virus/Lentivirus_packaging')">慢病毒包装：</span>慢病毒（Lentivirus，LV）是以HIV-1病毒为基础开发的基因递送载体，慢病毒属于逆转录病毒，基因组为单链正链RNA。区别一般的逆转录病毒载体，对分裂细胞和非分裂细胞均具有感染能力，可以将外源基因有效地整合到宿主染色体上，从而达到持久性表达。慢病毒感染能力较强，可有效地感染神经元细胞、肝细胞、心肌细胞、肿瘤细胞、内皮细胞、干细胞等多种类型的细胞，广泛应用于基因编辑、基因敲入和长期基因表达研究。</p>
      <p class="desc" style="margin-bottom: 10px;"><span style="color:#014492;font-weight:bold;cursor: pointer" @click="$router.push('/Virus/Adenovirus_packaging')">腺病毒包装：</span>腺病毒(Adenovirus，ADV)是一种没有包膜的直径为70～90 nm的病毒颗粒，具有较强的细胞和组织感染能力。腺病毒载体能够携带大容量的基因片段，适用于短时间内高表达的相关实验，可以快速获得目的产物，效率高。</p>
      <p class="desc"><span style="color:#014492;font-weight:bold;cursor: pointer" @click="$router.push('/Virus/Adeno_associated_virus')">腺相关病毒包装：</span>腺相关病毒（Adeno-associated virus，AAV），也称腺伴随病毒，属于微小病毒科依赖病毒属，是目前发现的一类结构最简单的单链DNA缺陷型病毒，需要辅助病毒（通常为腺病毒）参与复制。研究过程中采用的重组腺相关病毒载体(rAAV) 源于非致病的野生型腺相关病毒，由于其安全性好、宿主细胞范围广(分裂和非分裂细胞)、免疫源性低，在体内表达外源基因时间长等特点，被视为最有前途的基因递送载体之一，在基因功能研究、动物实验、基因治疗和疫苗研究中得到广泛应用。</p>
      </div>
      <div class="container">
      <div class="c-title">不同病毒的生物学特性比较<small>Comparison of biological characteristics of different viruses</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="">
            </el-table-column>
            <el-table-column
              prop="method2"
              width="240px"
              label="慢病毒">
              <template slot="header">
                <span @click="$router.push('/Virus/Lentivirus_packaging')">慢病毒</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="method3"
              width="240px"
              label="腺病毒">
              <template slot="header">
                <span @click="$router.push('/Virus/Adenovirus_packaging')">腺病毒</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="method4"
              label="腺相关病毒">
              <template slot="header">
                <span @click="$router.push('/Virus/Adeno_associated_virus')">腺相关病毒</span>
              </template>
              <template slot-scope="scope">
                <span v-html="scope.row.method4"></span>
              </template>
            </el-table-column>
          </el-table>
        </div>
  </div>
      <div class="container">
      <div class="c-title">服务类型<small>Service Type</small></div>
      <div class="container con">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`">
            <p style="margin-top: 10px;">{{item.name}}</p>
          </li>
        </ul>
      </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="compose-type1">
        <div class="container">
      <div class="c-title">服务优势<small>Service Advantages</small></div>
        <div class="neirong" style="display: flex">
          <div class="left ">
            <img src="@/assets/img/Virus/Virus/fwys_pt.png" class="img-fluid">
          </div>
          <div class="right">
            <div class="required">
              <p class="mb20">1.提供从基因合成、载体构建到病毒包装等一站式个性化解决方案;</p>
              <p class="mb20">2.严格质控标准，高安全性、高纯度、高滴度、高活性，表达时间长;</p>
              <p class="mb20">3.服务类型多样化，多种规格、多种病毒载体类型可供选择，接受定制化服务;</p>
              <p>4.周期短，高效、精准交付项目结果，售后无忧。</p>
            </div>
          </div>
        </div>
      </div>
      </div>
      <!-- <div class="container">
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <ul class="service_chan con">
          <li v-for="(item, index) in gene1" :key="index" :class="{active: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1">
            <div class="img">
              <img :src="`/static/images/fenzi_${index+1}${currentService === index ? '' : '_active'}.png`">
            </div>
            <p>{{item.name}}</p>
            <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
          </li>
        </ul>
        <div class="cons">
          <ul class="service_chan" style="width: 100%!important;">
            <li v-for="(item, index) in gene1" :key="index" @click="$router.push(item.ref)">
              <div class="img">
                <img :src="`/static/images/fenzi_${index+1}${currentService === index ? '' : '_active'}.png`" style="width: 50px;height: 55px;">
              </div>
              <p>{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>

      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData:[
        {
          method1:'病毒外壳',
          method2:'有包膜蛋白',
          method3:'无',
          method4:'无',
        },
        {
          method1:'颗粒直径',
          method2:'80~100 nm',
          method3:'60~90 nm',
          method4:'20~25 nm',
        },
        {
          method1:'基因组类型',
          method2:'dsRNA',
          method3:'dsDNA',
          method4:'ssDNA/dsDNA',
        },
        {
          method1:'基因组大小',
          method2:'8~10 kb',
          method3:'约36 kb',
          method4:'约4.7 kb',
        },
        {
          method1:'插入片段大小',
          method2:'6.5 kb（有效序列3.5 kb）',
          method3:'7.5 kb（有效序列6 kb）',
          method4:'3.7 kb（ssAAV）,1.7 kb（scAAV）',
        },
        {
          method1:'感染细胞类型',
          method2:'分裂细胞和非分裂细胞',
          method3:'分裂细胞和非分裂细胞',
          method4:'分裂细胞和非分裂细胞',
        },
        {
          method1:'整合方式',
          method2:'随机高频整合基因组',
          method3:'非整合',
          method4:'定向低频整合(rAAV不整合)',
        },
        {
          method1:'外源基因表达丰度及速度',
          method2:'中高水平表达，慢，2~3天开始表达，细胞水平72 h达到稳定，在体水平较差，约需96 h表达',
          method3:'高水平表达，快，1~2天开始表达，细胞水平36 h可达高峰，在体水平约72 h达高峰',
          method4:'高水平表达，慢，7~14天开始表达，细胞水平需表达约7天，动物水平需表达约2周',
        },
        {
          method1:'外源基因维持表达时间',
          method2:'长期稳定表达',
          method3:'＜1个月',
          method4:'稳定表达6个月以上',
        },
        {
          method1:'滴度检测方法',
          method2:'qPCR整合DNA',
          method3:'抗原抗体免疫染色',
          method4:'qPCR非整合DNA',
        },
        {
          method1:'滴度水平',
          method2:'1E+8 TU/mL~1E+10 TU/mL',
          method3:'1E+10 PFU/mL~1E+12 PFU/mL',
          method4:'1E+11 VGS/mL~1E+14 VGS/mL',
        },
        {
          method1:'组织或器官特异性',
          method2:'不明显，广谱',
          method3:'不明显，广谱',
          method4:'根据血清型可特异性感染',
        },
        {
          method1:'免疫原性',
          method2:'中等',
          method3:'强',
          method4:'很低',
        },
        {
          method1:'体内感染能力',
          method2:'低',
          method3:'高',
          method4:'高',
        },
        {
          method1:'细胞实验',
          method2:'首选，广谱，感染效率高',
          method3:'推荐插入基因片段较大情况下使用，适合原代非增殖细胞感染',
          method4:'AAV-DJ血清型适用',
        },
        {
          method1:'稳定细胞株筛选',
          method2:'可以，外源基因整合于宿主基因组，筛选简单',
          method3:'不可以，瞬时表达外源，基因传代后效果减弱',
          method4:'不可以',
        },
        {
          method1:'动物实验',
          method2:'适合，根据观察时间和注射部位选择',
          method3:'较适合(免疫原性高)，根据观察时间和注射部位选择',
          method4:'首选，根据观察时间和注射部位选择',
        },
        {
          method1:'局部注射',
          method2:'可用',
          method3:'可用',
          method4:'非常适合',
        },
        {
          method1:'系统注射',
          method2:'因滴度低，不推荐',
          method3:'效果一般',
          method4:'非常适合',
        },
        {
          method1:'安全性',
          method2:'高,已被用于CAR-T治疗作用于人体',
          method3:'一般',
          method4:'很高,已被用作基因治疗药物的载体',
        },
        {
          method1:'生物安全等级',
          method2:'BSL-2',
          method3:'BSL-2',
          method4:'BSL-1',
        },
        {
          method1:'应用范围',
          method2:'稳定株构建，gRNA文库筛选，体内应用',
          method3:'嗜肝，快速表达或短期表达，血液、心脏，细胞系等',
          method4:`dsDNA:基于不同的血清型，体内广泛应用；<br/>ssDNA:体内应用,快速表达`,
        },
      ],
      currentType: -1,
      currentService: -1,
      types: [
        {name: '慢病毒包装', img: '1', ref: '/Virus/Lentivirus_packaging'},
        {name: '腺病毒包装', img: '2', ref: '/Virus/Adenovirus_packaging'},
        {name: '腺相关病毒包装', img: '3', ref: '/Virus/Adeno_associated_virus'},
        ],
      gene1: [
        {name: '基因合成', ref: '/tec/gen_compose'},
        {name: '基因功能', ref: ''},
        {name: '基因检测', ref: '/sanger'},
        {name: '常规分子项目', ref: '/tec/DNA_extraction'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
    console.log(this.$route.meta.invisible)
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Virus/Virus_packaging.vue